import { render, staticRenderFns } from "./agendaLev.vue?vue&type=template&id=2ce608a0"
import script from "./agendaLev.vue?vue&type=script&lang=js"
export * from "./agendaLev.vue?vue&type=script&lang=js"
import style0 from "./agendaLev.vue?vue&type=style&index=0&id=2ce608a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports